import { checkNewRelicOnWindow } from './newRelic'

export interface UCFError extends Error {
  originInstance: string
}
/* eslint-disable */
export class UCFError extends Error {
  constructor(err: Error, ...params) {
    super(...params)

    // Set the prototype explicitly. More info here: https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(this, UCFError.prototype)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, UCFError)
    }

    this.originInstance = err.name
    this.message = `Caught ${this.originInstance}: ${err.message}`
    this.name = this.constructor.name
    this.stack = err.stack
  }
}

export const trackWithoutThrow = (err: Error, attrs?: any): void => {
  if (checkNewRelicOnWindow()) {
    // NR noticeError documentation allows for a second arg but the typings do not so
    // @ts-ignore
    window.newrelic.noticeError(new UCFError(err), attrs)
  } else {
    console.error(err)
  }
}

export const getBFFError = (bffError: any, defaultMessage: string) =>
  `${defaultMessage}${bffError?.message ? `: ${bffError?.message}` : ''}`

/**
 * Callback function to New Relic's newrelic.setErrorHandler
 * If it returns TRUE error will NOT be logged to New Relic
 * If it returns FALSE error WILL be logged to New Relic
 * @param err
 * @returns boolean
 */
export const shouldIgnoreError = (err: Error): boolean => {
  if (err instanceof UCFError) {
    return false
  }
  if (!window.SBMGlobal) {
    return false
  }
  if (err.message.includes('ADV Error:')) {
    return false
  }

  return true
}

export const errorLogger = (): void => {
  if (checkNewRelicOnWindow()) {
    window.newrelic.setErrorHandler(shouldIgnoreError)
  }
}
